<script>
    export default {
        name: "Mentorshipsection"
    }
</script>

<template>
  <div class="row boletos-section">
    <div class="container">
      <section class="section">
        <div class="text-boletos">
          <h2>
            <span class="title-boletos">Tenha uma mentoria especializada para sua pré-campanha!</span>
          </h2>
          <p>
            Muito mais que uma plataforma: O Voto Legal tem uma equipe de especialistas que irão te ajudar a começar a seu financiamento coletivo.
          </p>
          <p>
            Aprenda fazendo: Temos uma mentoria mão na massa, onde você aprende na prática como ter sucesso com a sua arrecadação.
          </p>
          <p>
            Da arrecadação a prestação de contas: Além da plataforma que facilita e dá segurança para seus doadores, tenha também um Mentor Voto Legal, que vai acompanhar de perto a construção da sua vaquinha digital.
          </p>
          <p>
            Junte-se ao nosso
            <a
              href="https://t.me/votolegal_eleicoes"
              target="_blank"
            >
              canal no Telegram
            </a>
            para acompanhar análises, recomendações e informações sobre financiamento eleitoral.
          </p>
        </div>

        <img
          class="img-authenticity"
          src="../../img/mentoria/mentoria.svg"
          alt="Integração votolegal"
        >
      </section>
    </div>
  </div>
</template>

<style lang="scss" scoped>
  .call-to-action-button {
    margin-top: 1rem;
    display: inline-block;
    padding: 0.6rem 2rem;
    color: #fff;
    text-align: center;
    text-transform: uppercase;
    font-size: 1em;
    font-weight: 600;
    border: 2px solid #fff;
    border-radius: 8px;
    background-color: transparent;
  }

  a {
    color: inherit;
    text-decoration: underline;
  }

    .boletos-section {
        background-color: #119783
    }

    .boletos-section .section {
      align-items: center;
      flex-wrap: wrap;
    }

    .section {
        overflow: hidden;
    }

    @media screen and (min-width: 768px) {
        .text-boletos {
            float: left;
            width: 50%;
            padding-right: 1rem;
            box-sizing: border-box;
        }
    }

    .title-boletos {
        color: #ffffff;
    }

    .text-boletos p {
        font-size: 18px;
        line-height: 2;
        margin-bottom: 1rem;
        color: #ffffff;

		@media (max-width: 913px) {
			margin-bottom: 2em;
		}
    }

    .img-authenticity {
        ---position: relative;
        margin-left: auto;
        margin-right: auto;
        display: block;
        width: 100%;

        @media (min-width: 768px) {
          width: 50%;
        }
    }

    .call-to-action {
      font-size: 18px;
      font-weight: bold;
      font-style: normal;
      color: #fff;
      text-transform: lowercase;
      text-decoration: underline;

      cursor: pointer;
      position: relative;

      &:hover{
        color: rgb(51, 204, 102);
      }
    }
</style>



// WEBPACK FOOTER //
// _source/javascript/components/mentorshipsection.vue